import React from 'react';
import MyAppointments from '../components/MyAppointments';

// RESIDENCE Team Google Calendar ID (Google Calendar > Settings > Integrate calendar > Calendar ID).
// Leave empty until it's filled in.
const TEAM_CALENDAR_ID = 'residenceteam239@gmail.com';

const FONT = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const styles = {
  page: { minHeight: '100vh', background: '#faf8f3', padding: '24px 16px', fontFamily: FONT, boxSizing: 'border-box' },
  wrap: { maxWidth: 1000, margin: '0 auto' },
  h1: { fontSize: 26, fontWeight: 700, color: '#1a1a1a', margin: '8px 0 4px' },
  muted: { color: '#7f7f7f', fontSize: 14, margin: '0 0 18px', lineHeight: 1.5 },
  card: { background: '#ffffff', border: '1px solid #d8c9a8', borderRadius: 10, padding: 20, marginBottom: 16 },
  h2: { fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px' },
  button: { display: 'inline-block', padding: '12px 20px', background: 'linear-gradient(180deg, #f6e7b4 0%, #d9b357 42%, #b98d2e 58%, #e8cc7a 100%)', color: '#1a1a1a', border: '1px solid #b8903a', borderRadius: 6, fontWeight: 700, fontSize: 13, textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '0.06em', marginRight: 10, marginBottom: 10 },
  buttonOff: { display: 'inline-block', padding: '12px 20px', background: '#f5efe1', color: '#7f7f7f', border: '1px solid #d8c9a8', borderRadius: 6, fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.06em', marginRight: 10, marginBottom: 10 },
  notice: { background: '#f5efe1', border: '1px solid #d8c9a8', borderRadius: 6, padding: 12, color: '#1a1a1a', fontSize: 14, marginBottom: 16 },
  step: { fontSize: 14, color: '#1a1a1a', lineHeight: 1.6, margin: '0 0 8px' },
  sub: { fontSize: 14, fontWeight: 700, color: '#8C6D1F', margin: '16px 0 6px', textTransform: 'uppercase', letterSpacing: '0.08em' },
};

const hasCalendar = Boolean(TEAM_CALENDAR_ID);
const embedUrl = hasCalendar
  ? `https://calendar.google.com/calendar/embed?src=${encodeURIComponent(TEAM_CALENDAR_ID)}&ctz=America%2FNew_York&mode=MONTH&showTitle=0&showPrint=0`
  : '';
// Google's add-to-calendar link uses the calendar ID in base64.
const addUrl = hasCalendar
  ? `https://calendar.google.com/calendar/u/0/r?cid=${btoa(TEAM_CALENDAR_ID)}`
  : '';
// Downloadable .ics file of the calendar (works for calendars shared publicly).
const icsUrl = hasCalendar
  ? `https://calendar.google.com/calendar/ical/${encodeURIComponent(TEAM_CALENDAR_ID)}/public/basic.ics`
  : '';

export default function CalendarPage() {
  return (
    <div style={styles.page}>
      <div style={styles.wrap}>
        <h1 style={styles.h1}>Team Calendar</h1>
        <p style={styles.muted}>Live trainings, Zoom events, and team dates. Sync it to your own calendar so you never miss one.</p>

        {!hasCalendar && (
          <div style={styles.notice}>The RESIDENCE team calendar isn't connected yet. Once its calendar ID is added, it will appear here.</div>
        )}

        <MyAppointments cardStyle={styles.card} h2Style={styles.h2} />

        <div style={styles.card}>
          <h2 style={styles.h2}>RESIDENCE Team Calendar</h2>
          {hasCalendar ? (
            <iframe
              title="RESIDENCE Team Calendar"
              src={embedUrl}
              style={{ width: '100%', height: 620, border: 0, borderRadius: 6 }}
            />
          ) : (
            <p style={styles.muted}>Calendar will load here.</p>
          )}
        </div>

        <div style={styles.card}>
          <h2 style={styles.h2}>Sync to Your Google Calendar</h2>
          {hasCalendar ? (
            <a href={addUrl} target="_blank" rel="noopener noreferrer" style={styles.button}>Add to Google Calendar</a>
          ) : (
            <span style={styles.buttonOff}>Add to Google Calendar</span>
          )}
          {hasCalendar ? (
            <a href={icsUrl} target="_blank" rel="noopener noreferrer" style={styles.button}>Download .ics file</a>
          ) : (
            <span style={styles.buttonOff}>Download .ics file</span>
          )}
          <p style={styles.muted}>Add to Google Calendar puts the team calendar in your own Google Calendar. The .ics file works with Apple Calendar and most other calendar apps.</p>
        </div>

        <div style={styles.card}>
          <h2 style={styles.h2}>Put It on Your Phone</h2>
          <div style={styles.sub}>iPhone (Google Calendar)</div>
          <p style={styles.step}>1. Do the "Add to Google Calendar" step above on your computer or phone.</p>
          <p style={styles.step}>2. Open Settings, tap Calendar, then tap Accounts and Add Account.</p>
          <p style={styles.step}>3. Choose Google and sign in with the Gmail account you use for your calendar.</p>
          <p style={styles.step}>4. Turn on Calendars and tap Save. The team calendar appears in your iPhone calendar.</p>

          <div style={styles.sub}>iPhone (Apple Calendar, using the .ics file)</div>
          <p style={styles.step}>1. Tap "Download .ics file" above and open the file on your iPhone.</p>
          <p style={styles.step}>2. Tap Subscribe when it asks. The calendar is added to your Calendar app.</p>

          <div style={styles.sub}>Android</div>
          <p style={styles.step}>1. Do the "Add to Google Calendar" step above.</p>
          <p style={styles.step}>2. Open the Google Calendar app and tap the menu, then Settings.</p>
          <p style={styles.step}>3. Make sure your Gmail account is listed and that the team calendar is turned on under that account.</p>
        </div>
      </div>
    </div>
  );
}
